import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {optimizeFilter} from '../../utils/filter.helper';
import {Article} from '../../models/articles/articles.model';
import {environment} from '../../../../environments/environment';
import {ArticlesFilter} from '../../models/articles/articles.filter';
import {User} from '../../models/users/users.model';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

export type TranslateArticle = Pick<Article, 'title' | 'shortDescription' | 'description'>;

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {
  private articlesUrl = environment.baseURL + environment.articles;

  constructor(private http: HttpClient) {
  }

  createOne(article: Article): Observable<Article> {
    return this.http.post<Article>(this.articlesUrl, article);
  }

  translate(article: TranslateArticle): Observable<TranslateArticle> {
    return this.http.post<TranslateArticle>(this.articlesUrl + '/translate', article);
  }

  getAll(query: ArticlesFilter): Observable<{ docs: Article[], total: number }> {
    return this.http.get<{ docs: Article[], total: number }>(this.articlesUrl, {params: optimizeFilter(query)}).pipe(
      tap(result => {
        for (const article of result.docs) {
          if (typeof article.createdBy === 'object') {
            article.author = article.createdBy as unknown as (User | undefined);
            article.createdBy = article.author?._id;
          }
        }
      }),
    );
  }

  getOne(id: string, selectFields?: string): Observable<Article> {
    const params = {
      populate: 'topics',
      ...(selectFields && { select: selectFields })
    };
    return this.http.get<Article>(`${this.articlesUrl}/${id}`, { params });
  }

  updateOne(article: Article, id: string): Observable<Article> {
    return this.http.put<Article>(`${this.articlesUrl}/${id}`, article);
  }

  deleteOne(id: string): Observable<Article> {
    return this.http.delete<Article>(`${this.articlesUrl}/${id}`);
  }
}
